export const ExportTemplatesRoute = {
  EXPORT_TEMPLATES: '/exporttemplates',
};

export const ExportTemplatesName = {
  EXPORT_TEMPLATES: 'export-templates',
};

export const TemplateType = Object.freeze({
  INSERTION_ORDER: 'insertion_order',
  VENDOR_PO: 'vendor_po',
  CLIENT_PROPOSAL: 'client_proposal',
  VENDOR_PROPOSAL: 'vendor_proposal',
  PRESENTATION: 'presentation',
});

// Map template types to document type labels (Order vs Proposal)
export const TEMPLATE_TYPE_TO_DOCUMENT_TYPE = Object.freeze({
  [TemplateType.INSERTION_ORDER]: 'Order',
  [TemplateType.VENDOR_PO]: 'Order',
  [TemplateType.CLIENT_PROPOSAL]: 'Proposal',
  [TemplateType.VENDOR_PROPOSAL]: 'Proposal',
  [TemplateType.PRESENTATION]: 'Proposal',
});

export const SectionType = Object.freeze({
  CAMPAIGN_OVERVIEW: 'campaign_overview',
  PRODUCT_INFORMATION: 'product_information',
  FLIGHT_INFORMATION: 'flight_information',
  SIGNATURE: 'signature',
  TITLE: 'title',
  TERMS_AND_CONDITIONS: 'terms_and_conditions',
  SUMMARY: 'summary',
  CALL_TO_ACTION: 'call_to_action',
});

// Map section types to their display labels
export const SECTION_TYPE_LABELS = Object.freeze({
  [SectionType.CAMPAIGN_OVERVIEW]: 'Campaign Overview',
  [SectionType.PRODUCT_INFORMATION]: 'Product Information',
  [SectionType.FLIGHT_INFORMATION]: 'Flight Information',
  [SectionType.SIGNATURE]: 'Signature',
  [SectionType.TITLE]: 'Title',
  [SectionType.TERMS_AND_CONDITIONS]: 'Terms and Conditions',
  [SectionType.SUMMARY]: 'Summary',
  [SectionType.CALL_TO_ACTION]: 'Call to Action',
});

// Object to map client/order record fields to their display labels
export const CampaignFieldName = Object.freeze({
  COMPANY_NAME: 'company_name',
  CONTACT_PERSON: 'contact_person',
  EMAIL: 'email',
  PHONE: 'phone',
  WEBSITE: 'website',
  CLIENT_ADDRESS: 'client_address',
  NAME: 'name',
  START_DATE: 'start_date',
  END_DATE: 'end_date',
  TOTAL_BUDGET: 'total_budget',
});

export const CAMPAIGN_FIELD_OPTIONS = Object.freeze([
  { field_name: CampaignFieldName.COMPANY_NAME, label: 'Client Name' },
  { field_name: CampaignFieldName.CONTACT_PERSON, label: 'Contact Person' },
  { field_name: CampaignFieldName.EMAIL, label: 'Contact Email' },
  { field_name: CampaignFieldName.PHONE, label: 'Contact Phone' },
  { field_name: CampaignFieldName.WEBSITE, label: 'Company Website' },
  { field_name: CampaignFieldName.CLIENT_ADDRESS, label: 'Client Address' },
  { field_name: CampaignFieldName.NAME, label: 'Name' },
  { field_name: CampaignFieldName.START_DATE, label: 'Start Date' },
  { field_name: CampaignFieldName.END_DATE, label: 'End Date' },
  { field_name: CampaignFieldName.TOTAL_BUDGET, label: 'Total Budget' },
]);

export const MAX_SIGNATURE_LINES = 4;
export const MAX_TERMS_AND_CONDITIONS = 10;
